import FormComponent from './Container/FormComponent';

export default FormComponent;
